export default __webpack_public_path__ + "static/media/img3.c28826d7.jpeg";